"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
require('rxjs/add/operator/map');
require('rxjs/add/operator/catch');
var Observable_1 = require("rxjs/Observable");
var core_1 = require('@angular/core');
var http_1 = require('@angular/http');
var interfaces_1 = require('./interfaces');
var FontPickerService = (function () {
    function FontPickerService(config, http) {
        this.config = config;
        this.http = http;
        this.apiKey = "";
        this.baseUrl = 'https://www.googleapis.com/webfonts/v1/webfonts';
        this.apiKey = config.apiKey;
    }
    /*
      Return all fonts avaliable from google fonts, may have sort parameter:
      date || alpha || style || trending || popularity
    */
    FontPickerService.prototype.getAllFonts = function (sort) {
        var requestUrl = this.baseUrl + '?key=' + this.apiKey;
        if (sort) {
            requestUrl = requestUrl.concat('&sort=' + sort);
        }
        return this.http.get(requestUrl)
            .map(function (res) { return res.json(); })
            .catch(this.handleHttpError);
    };
    /*
      Return observable of the requested font
    */
    FontPickerService.prototype.getRequestedFont = function (family) {
        var requestUrl = 'https://fonts.googleapis.com/css?family=' + family;
        return this.http.get(requestUrl)
            .map(function (res) { return res.json(); })
            .catch(this.handleHttpError);
    };
    /*
      Handler for possible http request errors
    */
    FontPickerService.prototype.handleHttpError = function (error) {
        var errMsg = (error.message) ? error.message :
            error.status ? error.status + " - " + error.statusText : 'Server error';
        return Observable_1.Observable.throw(errMsg);
    };
    FontPickerService = __decorate([
        core_1.Injectable(),
        __param(0, core_1.Inject(interfaces_1.FontPickerConfig)), 
        __metadata('design:paramtypes', [(typeof (_a = typeof interfaces_1.FontPickerConfig !== 'undefined' && interfaces_1.FontPickerConfig) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
    ], FontPickerService);
    return FontPickerService;
    var _a, _b;
}());
exports.FontPickerService = FontPickerService;



//////////////////
// WEBPACK FOOTER
// ./src/lib/font-picker.service.ts
// module id = 13
// module chunks = 0 1